/* Show the selected metal's photo first in the product gallery.

   Two halves:

   1. On load, read the variant->media map the section prints and float that
      variant's image to the front of the gallery with CSS `order`. This is
      what makes ?variant=<id> land on the right photo, and it is why each
      metal has a shareable URL, the same as Mayave.

   2. On click, the theme's picker updates ?variant= but re-renders the form,
      so rather than fight it we let the URL be the source of truth and
      re-apply ordering whenever it changes.

   Minimog's own variant-image grouping needs a FoxEcom app metafield this
   store does not have, hence doing it here. */
(function () {
  function setup() {
    var data = document.querySelector('[data-iv-variant-media]');
    if (!data) return null;
    var map;
    try { map = JSON.parse((data.textContent || '').trim()); } catch (e) { return null; }
    if (!map || !Object.keys(map).length) return null;

    var items = [].slice.call(document.querySelectorAll('.m-product-media--item'));
    if (items.length < 2) return null;
    items.forEach(function (el, i) {
      if (el.dataset.ivOrder === undefined) el.dataset.ivOrder = String(i);
    });
    return { map: map, items: items };
  }

  function mediaIdOf(el) {
    var own = el.getAttribute('data-media-id');
    if (own) return own;
    var inner = el.querySelector('[data-media-id]');
    return inner ? inner.getAttribute('data-media-id') : null;
  }

  var lastVid = null;
  var firstRunDone = false;

  /* When a product carries the theme's own variant-images metafield, the
     theme rebuilds the gallery per metal (only that metal's photos, already in
     order), so floating one photo with CSS `order` would fight it.  The theme
     only prints #variantGroup when that mode is on. */
  function grouped() {
    return !!document.querySelector('#variantGroup[type="application/json"]');
  }

  function apply() {
    if (grouped()) return;
    var ctx = setup();
    if (!ctx) return;
    var target = null;
    var m = location.search.match(/variant=(\d+)/);
    var vid = m && m[1];
    if (!vid) {
      var f = document.querySelector('[name="id"]');
      vid = f && f.value;
    }
    var mid = ctx.map[String(vid)];
    ctx.items.forEach(function (el) {
      var mine = mid && String(mediaIdOf(el)) === String(mid);
      el.style.order = mine ? '-1' : el.dataset.ivOrder;
      el.classList.toggle('iv-media--active', !!mine);
      if (mine) target = el;
    });

    /* Mayave's behaviour: choosing a metal brings that metal's photo into
       view rather than making the customer hunt for it. The gallery is a
       grid, so the page is scrolled to the image, not the scroller.

       Only on a real change, and never on first paint, or the page would
       yank itself downward the moment it loads. */
    if (target && firstRunDone && vid !== lastVid) {
      scrollToMedia(target);
    }
    lastVid = vid;
    firstRunDone = true;
  }

  /* Scroll so the image sits just below the sticky header, and stop there.
     `scroll-margin-top` would be simpler but the header height is dynamic. */
  function scrollToMedia(el) {
    if (prefersReducedMotion()) return;
    var header = document.querySelector('.m-header__wrapper, .m-header');
    var offset = header ? header.getBoundingClientRect().height + 16 : 24;
    var rect = el.getBoundingClientRect();
    var already = rect.top >= offset - 4 && rect.bottom <= window.innerHeight;
    if (already) return;
    var y = window.pageYOffset + rect.top - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function prefersReducedMotion() {
    return window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* The picker rewrites the query string without a navigation, so watch for
     it rather than binding to inputs the theme replaces. */
  function watchUrl() {
    var last = location.search;
    setInterval(function () {
      if (location.search !== last) { last = location.search; apply(); }
    }, 150);
  }

  /* Cullen's gallery: every photo stacked full size down the page, with a
     thumbnail rail pinned beside them that jumps to the one you pick. */
  function bindThumbnails() {
    var list = document.querySelector('.m-media-gallery__list');
    if (!list) return;

    /* The rail only earns its column when there is something to stack in it.
       10 of 33 products in this catalogue ship a single photo, and 4 ship two,
       so a hardcoded 84px column left an empty gutter and pushed the hero off
       centre on nearly half the catalogue.  The count drives the layout in CSS
       instead. */
    list.dataset.ivMedia = list.querySelectorAll('.m-product-media--item').length;

    /* Pin the hero before anything else.  This runs on every boot, not just
       the first, so a section re-render never leaves the gallery with no
       active item (which would drop the hero back into the 76px rail). */
    if (!list.querySelector('.iv-media--active')) {
      var firstItem = list.querySelector('.m-product-media--item');
      if (firstItem) firstItem.classList.add('iv-media--active');
    }

    buildRail(list);

    /* Every photo is on the page now, so there is no hero to swap and no
       click handler on the images themselves: they keep the theme's own
       PhotoSwipe zoom untouched.  Navigation lives in the rail. */
  }

  /* Cullen stacks every photo full size down the page AND offers a thumbnail
     rail beside them, so the gallery is genuinely tall and the buying panel
     has a long scroll to hold still against.  One grid cannot do both jobs at
     once, so the rail is built from lightweight clones and the theme's own
     media items are left untouched to stack.

     Cloning rather than moving matters: the originals keep the theme's
     PhotoSwipe zoom binding and the variant-to-media logic above, both of
     which look items up by `data-media-id`. */
  function buildRail(list) {
    /* The rail must be a SIBLING of the gallery inside the column that the
       CSS grid is declared on (`.m-main-product--media`).  The list's own
       parent is `.m-media-gallery__inner`, four levels down, and inserting
       there stacked the rail above the images in a 76px column instead of
       beside them. */
    var wrap = list.closest('.m-main-product--media');
    if (!wrap) return;
    /* insertBefore needs a DIRECT child of wrap as the reference node; the
       gallery itself is nested inside `.m-product-media--desktop`. */
    var anchor = wrap.firstElementChild;
    if (!anchor) return;

    var items = [].slice.call(list.querySelectorAll('.m-product-media--item'));
    var rail = wrap.querySelector('.iv-rail');

    /* A single photo has no rail to draw. */
    if (items.length < 2) { if (rail) rail.remove(); return; }

    if (!rail) {
      rail = document.createElement('div');
      rail.className = 'iv-rail';
      rail.setAttribute('role', 'tablist');
      rail.setAttribute('aria-label', 'Product images');
      wrap.insertBefore(rail, anchor);
    }

    /* Rebuild only when the media set actually changed, so a variant switch
       does not churn the DOM on every click. */
    var sig = items.map(function (el) { return el.getAttribute('data-media-id'); }).join(',');
    if (rail.dataset.sig === sig) return;
    rail.dataset.sig = sig;
    rail.innerHTML = '';

    items.forEach(function (item, i) {
      var src = item.querySelector('img');
      if (!src) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'iv-rail__thumb';
      b.setAttribute('data-media-id', item.getAttribute('data-media-id') || '');
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'View image ' + (i + 1) + ' of ' + items.length);

      var im = document.createElement('img');
      /* currentSrc is the size the browser actually chose; falling back to
         src keeps this working before the image has loaded. */
      im.src = src.currentSrc || src.src;
      im.alt = '';
      im.setAttribute('aria-hidden', 'true');
      im.loading = 'lazy';
      b.appendChild(im);
      rail.appendChild(b);
    });

    if (rail.dataset.bound !== '1') {
      rail.dataset.bound = '1';
      rail.addEventListener('click', function (ev) {
        var b = ev.target.closest('.iv-rail__thumb');
        if (!b) return;
        var id = b.getAttribute('data-media-id');
        /* One image shows at a time now, so a thumbnail promotes its photo
           into the stage instead of scrolling to it. */
        var idx = stageItems(list).findIndex(function (el) {
          return el.getAttribute('data-media-id') === id;
        });
        if (idx < 0) return;
        showIndex(list, idx);
      });
    }

    buildStage(wrap, list);
    markRail(list);
  }

  /* Cullen shows ONE large image at a time with < and > arrows.  The theme
     renders every photo stacked, so rather than rebuild its markup we turn the
     stack into a viewport one image tall and step it with the arrows.  The
     originals stay in the DOM in order, which keeps PhotoSwipe zoom and the
     variant-to-media logic working untouched. */
  function buildStage(wrap, list) {
    if (!wrap || wrap.querySelector('.iv-stage-nav')) return;
    var items = list.querySelectorAll('.m-product-media--item');
    if (items.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'iv-stage-nav';
    nav.innerHTML =
      '<button type="button" class="iv-stage-arrow iv-stage-arrow--prev" aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 4 7 12l8 8"/></svg></button>' +
      '<span class="iv-stage-count" aria-live="polite"></span>' +
      '<button type="button" class="iv-stage-arrow iv-stage-arrow--next" aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg></button>';

    var gallery = list.closest('.m-media-gallery, media-gallery') || list.parentElement;
    gallery.appendChild(nav);
    gallery.classList.add('iv-stage');

    nav.querySelector('.iv-stage-arrow--prev').addEventListener('click', function () { step(list, -1); });
    nav.querySelector('.iv-stage-arrow--next').addEventListener('click', function () { step(list, 1); });

    showIndex(list, 0);
  }

  function stageItems(list) {
    return [].slice.call(list.querySelectorAll('.m-product-media--item'));
  }

  function currentIndex(list) {
    var items = stageItems(list);
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('iv-stage--on')) return i;
    }
    return 0;
  }

  /* Wrapping rather than disabling at the ends: with three or four photos a
     dead arrow is more confusing than a loop. */
  function step(list, dir) {
    var items = stageItems(list);
    if (!items.length) return;
    var next = (currentIndex(list) + dir + items.length) % items.length;
    showIndex(list, next);
  }

  function showIndex(list, i) {
    var items = stageItems(list);
    if (!items.length) return;
    items.forEach(function (el, n) { el.classList.toggle('iv-stage--on', n === i); });
    var gallery = list.closest('.m-media-gallery, media-gallery') || list.parentElement;
    var count = gallery && gallery.querySelector('.iv-stage-count');
    if (count) count.textContent = (i + 1) + ' / ' + items.length;
    markRail(list);
  }

  /* The rail shows which photo the reader is currently looking at. */
  function markRail(list) {
    /* The rail is a sibling of the gallery on `.m-main-product--media`, not
       of the list (whose parent is `.m-media-gallery__inner`), so it has to be
       looked up from the same ancestor buildRail inserts it into. */
    var wrap = list && list.closest('.m-main-product--media');
    var rail = wrap && wrap.querySelector('.iv-rail');
    if (!rail) return;
    /* Whichever photo is currently staged is the one the rail marks. */
    var items = [].slice.call(list.querySelectorAll('.m-product-media--item'));
    var on = items.filter(function (el) { return el.classList.contains('iv-stage--on'); })[0];
    var id = (on || items[0] || {}).getAttribute
      ? (on || items[0]).getAttribute('data-media-id')
      : null;
    [].slice.call(rail.querySelectorAll('.iv-rail__thumb')).forEach(function (b) {
      var on = b.getAttribute('data-media-id') === id;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  /* Left/right arrow keys step the gallery once it has focus, which is what a
     keyboard user expects of a carousel.  Bound on the gallery rather than the
     document so arrow keys keep working normally everywhere else. */
  function watchKeys() {
    var list = document.querySelector('.m-media-gallery__list');
    if (!list || list.dataset.ivKeys === '1') return;
    var gallery = list.closest('.m-media-gallery, media-gallery') || list.parentElement;
    if (!gallery) return;
    list.dataset.ivKeys = '1';
    gallery.addEventListener('keydown', function (ev) {
      if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') return;
      ev.preventDefault();
      step(list, ev.key === 'ArrowRight' ? 1 : -1);
    });
  }

  /* In grouped mode the theme empties the gallery and refills it with the new
     metal's photos on every metal change.  The rail and the "1 / n" counter
     were built from the old set, so rebuild them from whatever is there now
     and start again on the first photo, which is that metal's main view. */
  function watchGallery() {
    var list = document.querySelector('.m-media-gallery__list');
    if (!list || list.dataset.ivWatch === '1' || !window.MutationObserver) return;
    list.dataset.ivWatch = '1';
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        bindThumbnails();
        showIndex(list, 0);
      }, 60);
    }).observe(list, { childList: true });
  }

  function boot() { apply(); bindThumbnails(); watchKeys(); watchUrl(); watchGallery(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { apply(); bindThumbnails(); watchGallery(); });
  window.addEventListener('popstate', apply);
})();
